export type WSIOError =
  | { type?: string; description?: number | WebSocket; message?: string }
  | undefined

export enum WSIOErrorTypes {
  TransportError = 'TransportError',
  InvalidToken = 'InvalidToken',
}
